module.exports = __webpack_public_path__ + "static/serb2b-logo-34b1521f37f1bece662bbdb1614709f2.svg";